import React, { Component } from 'react';
import { Link } from 'gatsby';
import cx from 'classnames';
import styles from './headerSections.module.css';

class HeaderSection extends Component {
  render() {
    return (
      <div className={styles.root}>
        <a className={styles.item} href="https://hiveos.farm">
          <div className={styles.main}>
            <span>Hive</span>&nbsp;<span className={styles.subMain}>OS</span>
          </div>
          <div className={styles.underText}>
            The Ultimate Mining Platform
          </div>
        </a>
        <Link className={cx(styles.item, styles.active)} to="/">
          <div className={styles.main}>
            <span>Hiveon</span>&nbsp;<span className={styles.subMain}>Pool</span>
          </div>
          <div className={styles.underText}>
            The Most Profitable Mining Pool
          </div>
        </Link>
        <a className={styles.item} href="https://hiveos.farm/asic">
          <div className={styles.main}>
            <span>Hiveon</span>&nbsp;<span className={styles.subMain}>ASIC</span>
          </div>
          <div className={styles.underText}>
            The Game-changing firmware
          </div>
        </a>
        <a className={styles.item} href="https://forum.hiveos.farm">
          <div className={styles.main}>
            <span>Hiveon</span>&nbsp;<span className={styles.subMain}>Community</span>
          </div>
          <div className={styles.underText}>
            Miners Forum and Knowledge Base
          </div>
        </a>
      </div>
    );
  }

};


export default HeaderSection;
